<template>
  <b-row style="position:relative">
    <b-col cols="6">
      <b-form
        @submit.prevent="onSubmitIdentify"
        @reset="reset"
        autocomplete="off"
        ref="bsave"
      >
        <div class="mb-2 position-relative">
          <div class="multiselect-lbl" v-if="shopObject && shopObject.eid">
            {{ $t("Shop") }}
          </div>
          <multiselect
            v-model="shopObject"
            :options="shopList"
            placeholder="Select shop"
            track-by="eid"
            label="name"
            :multiple="false"
            :translate="false"
            :disabled="shopDropdownDisabled"
          ></multiselect>
        </div>
        <FloatingLabel v-model="cnp" label="CNP" size="sm" type="text" />
        <FloatingLabel v-model="phone" label="Phone" size="sm" type="text" />

        <div style="text-align: right;">
          <b-button type="reset" variant="secondary">{{
            $t("Clear")
          }}</b-button>
          <b-button
            type="submit"
            variant="success"
            :disabled="submitFormIdentifyDisabled"
            >{{ $t("Identify") }}</b-button
          >
        </div>
      </b-form>
      <b-form class="mt-3" v-if="step == 2" @submit.prevent="onSubmitDeposit">
        <div class="mb-2 position-relative">
          <div>{{ $t("Max amount") }} {{ maxAmount }} RON</div>
          <br />
          <FloatingLabel
            v-model.number="amount"
            label="Amount"
            size="sm"
            type="number"
            step="0.01"
          />
          <div class="text-center">
            {{ $t("Deposit") }} : {{ round(netAmount, 2) }} | {{ $t("Tax") }}
            {{ round(taxAmount, 2) }} | {{ $t("Total") }}:
            {{ round(amount, 2) }}
          </div>
          <div style="text-align: right;">
            <b-button
              type="submit"
              variant="success"
              :disabled="submitFormDepositDisabled"
              >{{ $t("Deposit") }}</b-button
            >
          </div>
        </div>
      </b-form>
    </b-col>
    <b-col sm="6">
      <div v-if="step >= 2">
        <b-table
          v-if="identifyResponse != null"
          :fields="tableFields"
          :items="[identifyResponse]"
          stacked
          small
        >
          <template v-slot:cell(account_sub_status)="{ value }">
            <div>
              <i v-if="value == 3" class="flaticon-user-ok" />
              <i v-else class="flaticon-exclamation-2" />
            </div>
          </template>
          <template v-slot:cell(limits)="{ value }">
            <div>
              <tr v-for="(limit, key) in value" :key="key">
                <strong>{{ key }}</strong>
                :
                {{
                  round(limit.accumulated_amount, 2)
                }}
                /
                {{
                  round(limit.limit_amount, 2)
                }}
                ron /
                {{
                  limitPeriods[limit.period_type - 1]
                }}
              </tr>
            </div>
          </template>
        </b-table>
        <div v-else class="text-danger">
          Jucatorul cu detaliile introduse nu exista.
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf, successConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";
import Multiselect from "@/components/multiselect-filters";

export default {
  components: {
    FloatingLabel,
    Multiselect
  },
  name: "OnlineCashTransactionDeposit",
  data: function() {
    return {
      step: 1,
      shopDropdownDisabled: false,
      shopObject: null,
      cnp: "",
      phone: "",
      amount: 0,

      tableFields: [
        { key: "first_name", label: "Prenume" },
        { key: "last_name", label: "Nume" },
        { key: "email", label: "Email" },
        { key: "cnp", label: "CNP" },
        { key: "account_sub_status", label: "KYC" },
        { key: "limits", label: "Limita" }
      ],
      limitPeriods: [
        "Zi",
        "Saptamana",
        "Luna",
        "3 Luni",
        "6 Luni",
        "An",
        "3 Ani",
        "3 Zile",
        "Nelimitat"
      ],

      depositPressed: false
    };
  },
  computed: {
    shopList() {
      return this.$store.getters["cache/shops"];
    },
    phoneValid() {
      return this.phone && this.phone.length == 10;
    },
    submitFormIdentifyDisabled() {
      return (
        !this.shopObject ||
        !this.shopObject.eid ||
        this.cnp.length != 13 ||
        !this.phoneValid
      );
    },
    submitFormDepositDisabled() {
      return (
        this.amount <= 0 || this.amount > this.maxAmount || this.depositPressed
      );
    },
    maxAmount() {
      if (this.identifyResponse != null) {
        let amount;
        for (const limit of Object.values(this.identifyResponse.limits)) {
          let difference = limit.limit_amount - limit.accumulated_amount;
          if (typeof amount === "undefined" || difference < amount) {
            amount = difference;
          }
        }
        return amount;
      }
      return 0;
    },
    netAmount() {
      return this.amount * 0.98;
    },
    taxAmount() {
      return this.amount * 0.02;
    }
  },
  mounted() {
    const _this = this;
    Promise.all([this.$store.dispatch("cache/fetch", "shops").catch(e => e)])
      .catch(err => {})
      .finally(() => {});
  },
  watch: {},
  methods: {
    reset() {
      this.shopDropdownDisabled = false;
      this.shopObject = null;
      this.cnp = "";
      this.phone = "";
      this.amount = 0;
      this.step = 1;
      this.identifyResponse = null;
    },
    onSubmitIdentify(evt) {
      this.depositPressed = false;
      this.$store
        .dispatch("onlineCashTX/identify", {
          shop_id:
            this.shopObject && this.shopObject.eid ? this.shopObject.eid : null,
          cnp: this.cnp,
          phone: this.phone
        })
        .then(resp => {
          this.identifyResponse = resp.data;
          this.shopDropdownDisabled = true;
          this.step = 2;
          if (this.$refs.inputAmount) {
            this.$refs.inputAmount.focus();
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, errorConf("Eroare"));
        });
    },
    onSubmitDeposit() {
      // 1 - supply; 2 - withdrawal
      // const loader = this.$loading.open({
      //   container: this.$refs.bsave
      // });

      const apiAction = "onlineCashTX/deposit";

      const postData = {};
      postData.shop_id =
        this.shopObject && this.shopObject.eid ? this.shopObject.eid : null;
      postData.customer_id = this.identifyResponse.customer_id;
      postData.gross_amount = parseFloat(this.amount);

      this.$store
        .dispatch(apiAction, postData)
        .then(resp => {
          const msg =
            this.$t("Contul a fost alimentat cu") +
            " " +
            resp.data.net_amount +
            " RON";
          this.showSuccessNotification(msg);
          this.reset();
          this.$emit("successfulDeposit");
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          // loader.close();
        });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    round(value, decimals) {
      let v = value;
      if (!v) v = 0;
      return Number(Math.round(v + "e" + decimals) + "e-" + decimals).toFixed(
        decimals
      );
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep #balance-table-deposit th {
  text-transform: capitalize;
}
</style>
